import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
function matchWildCardPath(currentPath: string, path: string): boolean {
  const pathToMatch = path.replace('/*', '');
  return currentPath.includes(pathToMatch);
}
export default function useIsActivePath(paths) {
  const $ = _c(11);
  const currentPath = usePathname();
  if (Array.isArray(paths)) {
    let t0;
    if ($[0] !== currentPath || $[1] !== paths) {
      let t1;
      if ($[3] !== currentPath) {
        t1 = path => currentPath.endsWith(path) || path.endsWith("*") ? matchWildCardPath(currentPath, path) : false;
        $[3] = currentPath;
        $[4] = t1;
      } else {
        t1 = $[4];
      }
      t0 = paths.some(t1);
      $[0] = currentPath;
      $[1] = paths;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  if (paths.endsWith("*")) {
    let t0;
    if ($[5] !== currentPath || $[6] !== paths) {
      t0 = matchWildCardPath(currentPath, paths);
      $[5] = currentPath;
      $[6] = paths;
      $[7] = t0;
    } else {
      t0 = $[7];
    }
    return t0;
  }
  let t0;
  if ($[8] !== currentPath || $[9] !== paths) {
    t0 = currentPath.endsWith(paths);
    $[8] = currentPath;
    $[9] = paths;
    $[10] = t0;
  } else {
    t0 = $[10];
  }
  return t0;
}